import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "@sentry/react";

import { QueryClientProvider } from "./query-client";
import { ErrorFallback } from "../shared/error-fallback";

export function Providers(props: React.PropsWithChildren) {
  return (
    <QueryClientProvider>
      <ErrorBoundary
        fallback={(state) => <ErrorFallback error={state.error} />}
      >
        {props.children}
        <Toaster position="top-right" />
      </ErrorBoundary>
    </QueryClientProvider>
  );
}
